// @react/hooks/useForm.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { formStore } from '@core/stores';

/**
 * React hook for Form operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useForm } from '@react/hooks';
 *
 * const FormList = observer(() => {
 *   const store = useForm();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useForm() {
  return formStore;
}
